import type { ComponentProps } from 'react';
import { Button as DsButton } from '@repo/design-system/components/ui/v2/button';

/**
 * The CRM's Button: the Remote Leverage design system's v2 Button (TS-1681), copied from Hriq.
 * Same props as before (`variant`, `size`, `asChild`), plus the design system's `loading`.
 * `cta` (a green primary action) is the design system's `success`; every other variant and
 * size is the design system's own.
 */
type DsProps = ComponentProps<typeof DsButton>;
type DsVariant = NonNullable<DsProps['variant']>;

export type ButtonProps = Omit<DsProps, 'variant'> & { variant?: DsVariant | 'cta' };

export function Button({ variant, ...props }: ButtonProps) {
  return <DsButton variant={variant === 'cta' ? 'success' : variant} {...props} />;
}
